export default __webpack_public_path__ + "static/media/logo-small-w2.3ef71012.png";